import React from 'react'
import { useTranslation } from 'react-i18next'

import { renderPaginatedListText } from '../common/PaginatedListTable'

interface HistoryDeviceNameRecord {
    device_id?: string | null
    device_address?: string | null
    device_name?: string | null
    current_device_name?: string | null
}

interface HistoryDeviceNameDisplayProps {
    record: HistoryDeviceNameRecord
    fallback?: string
}

const deviceNameStackStyle: React.CSSProperties = {
    display: 'grid',
    gap: 2,
    maxWidth: '100%',
}

const currentDeviceNameStyle: React.CSSProperties = {
    color: 'rgba(0, 0, 0, 0.45)',
    fontSize: 12,
    lineHeight: 1.4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}

export const HistoryDeviceNameDisplay: React.FC<
    HistoryDeviceNameDisplayProps
> = ({ record, fallback }) => {
    const { t } = useTranslation('history')
    const historicalDeviceName =
        record.device_name ||
        record.device_address ||
        record.device_id ||
        fallback ||
        t('messages.deviceUnavailable')
    const currentDeviceName = record.current_device_name?.trim()

    if (!currentDeviceName || currentDeviceName === historicalDeviceName) {
        return <>{renderPaginatedListText(historicalDeviceName)}</>
    }

    const currentDeviceNameLabel = t('table.currentDeviceName', {
        name: currentDeviceName,
    })

    return (
        <span style={deviceNameStackStyle}>
            {renderPaginatedListText(historicalDeviceName)}
            <span style={currentDeviceNameStyle} title={currentDeviceNameLabel}>
                {currentDeviceNameLabel}
            </span>
        </span>
    )
}
